import { redirect } from '@tanstack/react-router'

/* The analytics pages lived under /reports until "Reports & Analytics" split
   them: charts and trends moved to /analytics, and /reports is kept for real
   figure reports (the X-Report today). A saved /reports/sales link lands on
   /analytics/sales with its date filter intact. */
export function redirectToAnalytics({ location }: { location: { href: string } }): never {
  throw redirect({ href: location.href.replace(/^\/reports(?=\/|\?|$)/, '/analytics'), replace: true })
}
